import React from 'react';
import { GenericConfirmationModal } from '@ydistri/ds';

interface CustomExportConfirmationModalProps {
  title: string;
  confirmationButtonLabel: string;
  message?: string;
  onConfirmed: () => void;
  onCanceled: () => void;
  running: boolean;
}

export const customExportStartConfirmationMessage =
  'This will start and automated export to the server. Continue?';

const CustomExportConfirmationModal: React.FC<CustomExportConfirmationModalProps> = ({
  title,
  confirmationButtonLabel,
  message = customExportStartConfirmationMessage,
  onConfirmed,
  onCanceled,
  running,
}) => (
  <GenericConfirmationModal
    title={title}
    message={message}
    onConfirmed={onConfirmed}
    onCanceled={onCanceled}
    confirmationButtonLabel={confirmationButtonLabel}
    running={running}
  />
);

export default CustomExportConfirmationModal;
